import React from 'react';
import PropTypes from 'prop-types';
import {getSliderStyle} from '../RangeSlider.utils';
import style from '../style.module.scss';

const INPUT_TYPE_RANGE = 'range';

/**
 * Input
 *  - Type Range Input
 */
export function Input(props) {
  const onChange = (event) => {
    // console.log(event)
    setValueOfFrame(event.target.valueAsNumber);
  };

  const setClassName = () => {
    const classList = [style.input];
    if (props.customThumb) {
      classList.push(style.customThumb);
    }
    return classList.join(' ');
  };

  const onKeyDown = (event) => {
    if (
         (
          event.keyCode === 37 ||
          event.keyCode === 38 ||
          event.keyCode === 39 ||
          event.keyCode === 40
        ) &&
        props.keyboardStep
       ) {
      event.preventDefault();
      // console.log(event)
      const currentFrameValue = props.value; //event.target.valueAsNumber;
      props.keyboardStep
        ? setUpdatedValueOfFrame(event)
        : setValueOfFrame(currentFrameValue);
    }
  };

  const setUpdatedValueOfFrame = (event) => {
    if (event.keyCode === 39) {
      if(props.ariaInterval !== props.altTextData.length - 1){
        if(props.altTextData[props.ariaInterval + 1].keyboardStep !== ""){
          setValueOfFrame(parseFloat(props.altTextData[props.ariaInterval + 1].keyboardStep));
        }
        else{
          if(props.value !== props.max){
            setValueOfFrame(props.value + props.step)
          }
        }
      }
      else{
        if(props.value !== props.max && props.altTextData[props.ariaInterval].keyboardStep === ""){
          setValueOfFrame(props.value + props.step)
        }
      }
    } else if (event.keyCode === 37) {
      if(props.ariaInterval !== 0){
        if(props.altTextData[props.ariaInterval - 1].keyboardStep !== ""){
          setValueOfFrame(parseFloat(props.altTextData[props.ariaInterval - 1].keyboardStep));
        }
        else{
          if(props.value !== props.min){
            setValueOfFrame(props.value - props.step)
          }
        }
      }
      else{
        if(props.value !== props.min && props.altTextData[props.ariaInterval].keyboardStep === ""){
          setValueOfFrame(props.value - props.step)
        }
      }
    }
  };

  const setValueOfFrame = (value) => {
    props.onChange(value);
  };
  return (
    <>
      <input
        id={'rangeSlider_'+props.labelledby}
        name={props.labelledby}
        role='slider'
        min={props.min}
        max={props.max}
        step={props.step}
        value={props.value}
        onKeyDown={onKeyDown}
        onChange={onChange}
        type={INPUT_TYPE_RANGE}
        className={setClassName()}
        aria-valuemin={props.min}
        aria-valuemax={props.max}
        aria-valuenow={props.value}
        aria-valuetext={props.inputLabel}
        aria-labelledby={props.labelledby}
        aria-label={props.ariaLabel}
        style={getSliderStyle(props)}
      />
    </>
  );
}

Input.propTypes = {
  /**
   * min value
   */
  min: PropTypes.number,
  /**
   * max value
   */
  max: PropTypes.number,
  /**
   * current value
   */
  value: PropTypes.number,
  /**
   * The value of a step
   */
  step: PropTypes.number,
  /**
   * KeyboardStep is used to increase a fixed number of steps in arrow right and arrow left
   */
  // keyboardStep: [PropTypes.number, PropTypes.string],
  /**
   * Function to call on value change
   */
  onChange: PropTypes.func,
  /**
   * Boolean to set if Input should display a Custom Thumb
   */
  customThumb: PropTypes.bool,
  /**
   * Label for input(used as aria-label)
   */
  inputLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
  nextAria: PropTypes.object,
  prevAria: PropTypes.object,
};

Input.defaultProps = {
  min: 0,
  max: 10,
  value: 1,
  step: 1,
  customThumb: true,
  autoFocus: false,
  inputLabel: 'aria-label',
};
